export default "__VITE_ASSET__Cm4jJoTH__"